// src/lib/axios.ts
import axios, { AxiosError, type AxiosResponse } from "axios";
import { clearOnLogout, getToken } from "@/lib/utils";
import toast from "@/lib/toast";


export const getRole = (): string => {
  const possibleRoles = ["distributor", "retailer"];


  const savedRole = localStorage.getItem("role") ?? "";
  if (possibleRoles.includes(savedRole)) {
    return savedRole;
  }

 
  const roleFromUrl = (window.location.pathname.split("/")[1] ?? "").trim();
  if (possibleRoles.includes(roleFromUrl)) {
    localStorage.setItem("role", roleFromUrl);
    return roleFromUrl;
  }
return "";
};



/**
 * Compute baseURL dynamically
 * - On localhost, hit Vite proxy (relative URL)
 * - On prod, hit real API
 */
const getBaseUrl = (): string => {
  const role = getRole();
   let apiRole=role;
   if(role==="retailer"){
    apiRole="dretailer"
   }
  if (window.location.hostname === "localhost") {
   
    return`${import.meta.env.VITE_API_TARGET_URL}${apiRole}/`;
  }

  return `${import.meta.env.VITE_API_TARGET_URL}${apiRole}/`;
};

/**
 * Public request (no token)
 */
export const createPublicRequest = () => {
  const instance = axios.create();

  instance.interceptors.request.use((config) => {
    config.baseURL = getBaseUrl();
    return config;
  });

  instance.interceptors.response.use(
    (res: AxiosResponse) => res,
    (error: AxiosError) => {
      toast.error(error.response?.data?.message || error.message || "Error");
      return Promise.reject(error);
    }
  );

  return instance;
};

export const publicRequest = createPublicRequest();

/**
 * Private request (with bearer token)
 */
export const createPrivateRequest = () => {
  const instance = axios.create();

  instance.interceptors.request.use((config) => {
    config.baseURL = getBaseUrl();        

    const token = getToken("referraltoken");
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    // const token = getToken("referraltoken");
    // if (token) {
    //   config.headers = config.headers ?? {};
    //   config.headers.Authorization = `Bearer ${token}`;
    // }

    // Remove Content-Type for GET requests
    if (config.method?.toLowerCase() === "get") {
      delete config.headers["Content-Type"];
    }

    return config;
  });

  instance.interceptors.response.use(
    (res: AxiosResponse) => res,
    (error: AxiosError) => {
      const status = error.response?.status;
      const message = (error.response?.data as any)?.message || error.message;

      if (status === 401) {
        if (message.toLowerCase().includes("token expired")) {
          clearOnLogout();
          
          window.location.href = "/";
          toast.warning("Token expired, please login");
        } else {
          window.location.href = "/";
          toast.warning("Token expired, please login");
        }
      } else {
        toast.error(message || "Some error occurred");
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export const privateRequest = createPrivateRequest();
